import { useContext } from "react";
import debug from "debug";
import { getConfig } from "@jti/fe-common";
import { ConfigContext } from "./contexts";
const log = debug("desjti:configProvider:useConfig");
export const useConfig = () => {
    try {
        const _config = useContext(ConfigContext);
        if (!_config) {
            throw new Error("useConfig hook used outside of ConfigProvider");
        }
        return _config;
    }
    catch (error) {
        if (error instanceof Error) {
            log(error.message);
        }
        // the deprecated getConfig function is used here to reduce changes in tests as getConfig is most convenient to mock
        return getConfig();
    }
};
//# sourceMappingURL=useConfig.js.map